import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { formatDocumentVersionRef, formatSegmentRef, type DocumentVersionRef } from "../../../../shared/references/contentReferences";
import { SelectionToChat, type ChatReference } from "../../../chatReferences";

interface AskAboutSegmentProps {
  projectId: string | undefined;
  version: DocumentVersionRef | null;
  segmentPath: string;
  /** The segment's name; `null` for a document without segments. */
  name: string | null;
  /** What the segment lies in and a selection sends with it, such as the annotation set drawn on it (PC-6). */
  enclosing?: Omit<ChatReference, "quote"> | null;
  children: ReactNode;
}

/** Selecting text in one segment asks the agent about it, by its segment reference (F96), where the view offers it. */
export default function AskAboutSegment({ projectId, version, segmentPath, name, enclosing = null, children }: AskAboutSegmentProps) {
  const { t } = useTranslation();
  if (projectId === undefined || version === null) return children;
  const reference = segmentPath === "" ? formatDocumentVersionRef(version) : formatSegmentRef(version, segmentPath);
  const segment = (
    <SelectionToChat projectId={projectId} subject={{ reference, name: name ?? t("chatReferences.documentText") }}>
      {children}
    </SelectionToChat>
  );
  return enclosing === null ? segment : <SelectionToChat projectId={projectId} subject={enclosing}>{segment}</SelectionToChat>;
}
